/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Subtitle_File_DescInputs */



/**
* | output |
* | --- |
* | "SRT, VTT, SCC, MCC formats" |
*
* @param {File_Export_Subtitle_File_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_subtitle_file_desc = /** @type {((inputs?: File_Export_Subtitle_File_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Subtitle_File_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formats SRT, VTT, SCC, MCC")
	if (locale === "de") return /** @type {LocalizedString} */ ("SRT-, VTT-, SCC- und MCC-Formate")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formati SRT, VTT, SCC, MCC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("форматы SRT, VTT, SCC, MCC")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formatos SRT, VTT, SCC, MCC")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("SRT、VTT、SCC、MCC 格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SRT、VTT、SCC、MCC 形式")
	if (locale === "hi") return /** @type {LocalizedString} */ ("SRT, VTT, SCC, MCC प्रारूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatos SRT, VTT, SCC e MCC")
	return /** @type {LocalizedString} */ ("SRT, VTT, SCC, MCC formats")
});